import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import { DropDownWithLabel } from '../../../component/dropDown';
import { ImagePicker } from '../../../component/imagePicker';
import { Input } from '../../../component/input';
import { AddModal } from '../../../component/modal';
import { useAddHotelDetailsMutation } from '../../../store/hotel/api';
import { roomTypesArr } from '../../../utils/module';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { addHotelDetailsValidation } from './validation';

type IAddRoom = {
  show?: boolean;
  hotelID: string;
  setShow: Dispatch<SetStateAction<boolean>>;
};
type FormikValues = {
  roomType: string;
  noOfRooms: number;
  price: string;
  file: File[] | null;
};
export const AddRoom: FC<IAddRoom> = ({ setShow, hotelID }) => {
  const [addHotelDetails, { isLoading: isAdding }] =
    useAddHotelDetailsMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file);
  };
  const handleAddHotel = (values: FormikValues) => {
    if (!values.file) return showErrorToast('hotel picture is required');
    const payload = new FormData();
    payload.append('roomType', values.roomType.toLowerCase());
    payload.append('price', values.price);
    payload.append('hotel', hotelID);
    payload.append('noOfRooms', values.noOfRooms.toString());
    values.file.forEach((file) => {
      payload.append('file', file);
    });

    addHotelDetails({ body: payload, id: hotelID })
      .unwrap()
      .then((res) => {
        showSuccessToast(res.message);
        setShow(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        roomType: '',
        noOfRooms: 1,
        file: null,
        price: ''
      },
      validationSchema: addHotelDetailsValidation,
      onSubmit: handleAddHotel
    });

  return (
    <AddModal
      title="Add Room"
      disableBtn={isAdding}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
      btnTxt={'Add Room'}
      isLoading={isAdding}
    >
      <Container>
        <Row>
          <CustomDropDown
            label="Type"
            value={values.roomType}
            onSelect={(item) => {
              setFieldValue('roomType', item);
            }}
            options={roomTypesArr}
          />
          <CustomInput
            labelText="Price"
            value={values.price}
            placeholder={'Enter price'}
            onChange={handleChange('price')}
            errorMessage={touched.price ? errors.price : ''}
          />
        </Row>

        <Row>
          <CustomInput
            labelText={'Number of rooms'}
            value={values.noOfRooms}
            type={'number'}
            min={1}
            onChange={handleChange('noOfRooms')}
            errorMessage={touched.noOfRooms ? errors.noOfRooms : ''}
          />
        </Row>
        <CustomImageUpload onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;
  padding-bottom: 32px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;
const CustomDropDown = styled(DropDownWithLabel)`
  flex: 0.46;
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
